import { Injectable } from '@angular/core';
import { StickerData } from './sticker-list-controller';
import { BehaviorSubject } from 'rxjs';
import { Mesh } from 'three';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Injectable({
  providedIn: 'root',
})
export class StickerListControllerService {
  public attachStickers: StickerData[] = [];
  public attachStickers$: BehaviorSubject<StickerData[]> = new BehaviorSubject<StickerData[]>(
    this.attachStickers,
  );
  public stickerMeshes: Array<Array<Mesh>> = [];

  private _stickerCount: number = 0;

  constructor() {}

  get stickerCount(): number {
    this._stickerCount++;
    return this._stickerCount;
  }

  public clearAll(): void {
    // 1) 데이터 배열 초기화
    this.attachStickers.length = 0;
    this.stickerMeshes.length = 0;

    // 2) 카운터 초기화 (원한다면)
    this._stickerCount = 0;

    // 3) 변경된 배열 emit
    this.attachStickers = [];
    this.stickerMeshes = [];
    this.attachStickers$.next(this.attachStickers);
  }

  public addAttachSticker(sticker: StickerData): void {
    this.attachStickers.unshift(sticker);
    this.attachStickers$.next(this.attachStickers);
  }

  public removeAttachSticker(index: number): void {
    this.attachStickers.splice(index, 1);
    this.stickerMeshes.splice(index, 1);

    this.stickerMeshes.forEach((meshes, index) => {
      meshes.forEach((mesh) => (mesh.renderOrder = this.stickerMeshes.length - index));
    });

    this.attachStickers$.next(this.attachStickers);
  }

  public addStickerMeshes(meshes: Array<Mesh>): void {
    this.stickerMeshes.unshift(meshes);
  }

  public getRenderOreder(): number {
    if (this.stickerMeshes.length > 0) {
      console.log(`//-------------------------------------------------`);
      console.log(this.stickerMeshes[0][0]);
      console.log(`//-------------------------------------------------`);
    }
    return this.stickerMeshes.length > 0 ? this.stickerMeshes[0][0].renderOrder + 1 : 1;
  }

  public moveAttachSticker(from: number, to: number): void {
    moveItemInArray(this.attachStickers, from, to);
    moveItemInArray(this.stickerMeshes, from, to);

    this.stickerMeshes.forEach((meshes, index) => {
      meshes.forEach((mesh) => (mesh.renderOrder = this.stickerMeshes.length - index));
    });

    this.attachStickers$.next(this.attachStickers);
  }
}
